import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';

export interface PartidoComercialDTO {
  partido: string;
  descripcion: string;
}

@Injectable({
  providedIn: 'root',
})
export class PartidosComercialesService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.PARTIDOS_COMERCIALES}`;

  constructor(private http: HttpClient) {}

  getPartidosComerciales(): Observable<PartidoComercialDTO[]> {
    return this.http.get<PartidoComercialDTO[]>(this.apiUrl);
  }
}
